import * as Sentry from '@sentry/react';

export function sentryRedux() {
  return Sentry.createReduxEnhancer({
    actionTransformer: action => {
      const actionType = action.type;
      var payload = {};
      const typeList = [
        'PRODUCT_MENU: SET_FILTER',
        'PRODUCT_MENU: SET_SUB_FILTER',
        'PRODUCT_MENU: SET_COLOR',
        'SCENE: ITEM_PICKED_UP',
        'TAC: UPDATE_ITEM',
        'TAC: ADD_ITEM',
        'TAC: REMOVE_ITEM',
        'TAC: TAC_SET_WALL',
        'NAVIGATION: SET_VIEW',
      ];
      if (typeList.find(type => type === actionType)) {
        payload = action.payload;
        if (actionType === 'TAC: UPDATE_ITEM') {
          payload = action.payload.model.wall;
        } else if (actionType === 'SCENE: ITEM_PICKED_UP') {
          payload = action.payload.item.filter;
        }
      }

      return {
        type: actionType,
        payload: payload,
      };
    },
  });
}
